import { render, staticRenderFns } from "./order-invoicelist.vue?vue&type=template&id=2a2a8a08&"
import script from "./order-invoicelist.vue?vue&type=script&lang=js&"
export * from "./order-invoicelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports